import script from "./MyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyModal.vue?vue&type=script&setup=true&lang=ts"

import "./MyModal.vue?vue&type=style&index=0&id=234d445a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234d445a"]])

export default __exports__